export default __webpack_public_path__ + "static/media/macos.9a9a03ea.png";